"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remove = exports.load = exports.save = void 0;
var _cookies = require("@kiwicom/cookies");
const save = token => (0, _cookies.save)(_cookies.Cookie.UA_SESSION_TOKEN, token);
exports.save = save;
const load = () => (0, _cookies.load)(_cookies.Cookie.UA_SESSION_TOKEN);
exports.load = load;
const remove = () => (0, _cookies.remove)(_cookies.Cookie.UA_SESSION_TOKEN);
exports.remove = remove;